import http from './http'

function getGlobalSettings(params) {
  return http({
    method: 'GET',
    url: `/competition/global`,
    params
  })
}
function updateGlobalSettings(data) {
  return http({
    method: 'PUT',
    url: `/competition/global`,
    data
  })
}
function getGlobalCompetitions(params) {
  return http({
    method: 'GET',
    url: `/competition/global/leaderboard`,
    params
  })
}
function updateGlobalCompetitions(data) {
  return http({
    method: 'PUT',
    url: `/competition/global/leaderboard`,
    data
  })
}
function getCompetitions(params) {
  return http({
    method: 'GET',
    url: `/competition?mode=${params.mode}&offset=${params.offset}&limit=${params.limit}${params.search ? "&search=" + params.search : ""}`
  })
}
function getCompetition(params) {
  return http({
    method: 'GET',
    url: `/competition/${params.id}?date=${params.date}&from=${params.from}&to=${params.to}`,
  })
}
function getCompetitionUser(params) {
  return http({
    method: 'GET',
    url: `/competition/${params.id}/user/${params.userId}?date=${params.date}&from=${params.from}&to=${params.to}`,
  })
}

function createCompetition(data) {
  return http({
    method: 'POST',
    url: '/competition',
    data
  })
}
function updateCompetition(data) {
  return http({
    method: 'PUT',
    url: `/competition/${data.id}`,
    data
  })
}
function deleteCompetition(data) {
  return http({
    method: 'DELETE',
    url: `/competition/${data.id}`,
  })
}


export {
  getGlobalCompetitions,
  getCompetitions,
  getCompetition,
  getCompetitionUser,
  createCompetition,
  updateCompetition,
  deleteCompetition,
  getGlobalSettings,
  updateGlobalSettings,
  updateGlobalCompetitions
}
